import { render } from "./MySettings.vue?vue&type=template&id=1b045450"
import script from "./MySettings.vue?vue&type=script&lang=js"
export * from "./MySettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__